import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { Button, Card, Form, notification, Popconfirm, Tabs, Tooltip, Checkbox } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { API_URL, MEDIA_URL } from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import WithdrawStudentRequestFinalStage from '../../../components/Invoice/WithdrawStudentRequestFinalStage';
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
const TabPane = Tabs.TabPane

class AllWithdrawFinalStage extends Component {

  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    defaultPageSize: 10,
    showWithdrawForm: false,
    recordId: '',
    formAction: '',
    enableBTN: false
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      let { defaultPageSize } = this.state;
      this.setState({ exportParams: params })
      let data = await Request.getInvoiceWithdrawFinalStageRequests({
        ...params,
        regExFilters: [
          'studentName'
        ]
      });
      this.setState({ total: data.total })
      resolve(data)
    })
  }

  async componentDidMount() {

  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }

  withdrawStudent = async (data) => {
    if (!data.withdrawFinalStageNote) {
      return notification.error({
        message: 'Please enter withdraw reason.'
      })
    }
    let invoiceGenerationRecord = this.printInvoiceDate(data.recordId.nextInvoiceGenerationDates);
    data.invoiceGeneratedRecordId = invoiceGenerationRecord._id;
    data.recordId = data.recordId._id;
    let response = await Request.withdrawStudentFinalUpdate(data);
    if (!response.error) {
      if (this.table && this.table.current) {
        this.table.current.reload();
      }
      this.setState({ showWithdrawForm: false })
      notification.success({ message: response.msg });
    } else {
      notification.error({
        message: 'Error withdraw student.'
      })
    }
  }

  closeWithdrawFrom = () => {
    this.setState({ showWithdrawForm: false });
  }


  getWithDrawterm = (record) => {
    if (record && record.nextInvoiceGenerationDates && record.nextInvoiceGenerationDates.length > 0) {
      let foundWithDrawn = record.nextInvoiceGenerationDates.find(obj => {
        return obj.withdrawRequest === true;
      })
      return foundWithDrawn;
    }
  }


  printInvoiceDate = (nextInvoiceGenerationDates) => {
    if (nextInvoiceGenerationDates.length) {
      let generatedInvoices = nextInvoiceGenerationDates.filter(item => (item.withdrawRequest === true && item.withdrawRequstStatus === 'Pending'));
      return generatedInvoices.length > 0 ? generatedInvoices[0] : null;
    }
  }

  render() {
    const { dispatch } = this.props

    const { total, enableBTN, defaultPageSize, formAction, showWithdrawForm, recordId } = this.state;

    const columns = [
      {
        title: 'Action',
        key: 'checkboxMultiple',
        dataindex: 'checkboxMultiple',
        width: 40,
        render: (text, record) => (
          <React.Fragment>
            <div>
              <div className={styles.btnWrapper}>
                <Tooltip title="Perform action on Withdraw request">
                  &nbsp;&nbsp;&nbsp;<Button
                    loading={false}
                    className={styles.btn}
                    onClick={() => { this.setState({ recordId: record, showWithdrawForm: true }) }}
                    shape="circle"
                    icon="check"
                  />
                </Tooltip>
              </div>
            </div>
          </React.Fragment>
        )
      },
      {
        title: 'VID',
        key: 'id',
        dataIndex: 'id',
        sorter: true,
        width: 80,
        searchTextName: 'id',
        filterRegex: true
      },
      {
        title: 'Student Details',
        key: 'studentName',
        dataIndex: 'studentName',
        sorter: true,
        width: 200,
        searchTextName: 'studentName',
        filterRegex: true,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              <div>
                <Tooltip title="Click To Edit Details">
                  <a className={styles.btn} target={'_blank'}
                    href={`/inquiry/studentProfileDetails?id=${record._id}`}
                  >{text}</a>
                </Tooltip>
                <div><b>Mobile:-</b> {record.mobile}</div>
                <div><b>Email:-</b> {record.emailId}</div>
                <div><b>Student ID:-</b> {record.visaDesk.selectedCourse ? record.visaDesk.selectedCourse.instituteStudentId : 'NA'}</div>
                <div><b>University:-</b> {record.visaDesk.selectedCourse ? record.visaDesk.selectedCourse.universityInstitutionName : 'NA'}</div>
                <div><b>Term:-</b> {this.getWithDrawterm(record).invoiceNo}</div>
                <div><b>Course Name:-</b> {record.visaDesk.selectedCourse ? record.visaDesk.selectedCourse.courseName : 'NA'}</div>
                <div><b>Course Start Date:-</b> {record.visaDesk && record.visaDesk.courseStartDate ? moment(record.visaDesk.courseStartDate).format(dateFormat) : 'NA'}</div>
              </div>
            </React.Fragment>
          </div>
        )
      },
      // {
      //   title: 'Next Invoice Generation Date',
      //   key: 'nextInvoiceGenerationDates',
      //   dataIndex: 'nextInvoiceGenerationDates',
      //   width: 100,
      //   render: (text, record) => (
      //     <div className={styles.wrap}>
      //       <React.Fragment>
      //         <div>
      //           {this.printInvoiceDate(record.nextInvoiceGenerationDates) ? moment(this.printInvoiceDate(record.nextInvoiceGenerationDates).generationDate).format(dateFormat) : null}
      //         </div>
      //       </React.Fragment>
      //     </div>
      //   )
      // },
      {
        title: 'Withdraw Reason',
        key: 'withdrawReason',
        dataIndex: 'withdrawReason',
        width: 100,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              <div>
                {this.printInvoiceDate(record.nextInvoiceGenerationDates) ? this.printInvoiceDate(record.nextInvoiceGenerationDates).withdrawReason : null}
              </div>
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'Withdraw Request Date',
        key: 'withdrawDate',
        dataIndex: 'withdrawDate',
        width: 100,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              <div>
                {this.printInvoiceDate(record.nextInvoiceGenerationDates) ? moment(this.printInvoiceDate(record.nextInvoiceGenerationDates).withdrawReasonDate).format(dateFormat) : null}
              </div>
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'Documents',
        key: 'mailFromUniversity',
        dataIndex: 'mailFromUniversity',
        width: 100,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              <div>
                {
                  this.printInvoiceDate(record.nextInvoiceGenerationDates) &&
                    this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromUniversity &&
                    this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromUniversity.length &&
                    this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromUniversity[0].url ?
                    <div><b>Mail From Univerisity:</b> <a href={MEDIA_URL + this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromUniversity[0].url} target="_blank">View</a></div>
                    : null
                }
                {
                  this.printInvoiceDate(record.nextInvoiceGenerationDates) &&
                    this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromStudent &&
                    this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromStudent.length &&
                    this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromStudent[0].url ?
                    <div><br /><b>Mail From Student:</b> <a href={MEDIA_URL + this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromStudent[0].url} target="_blank">View</a></div>
                    : null
                }
                {
                  this.printInvoiceDate(record.nextInvoiceGenerationDates) &&
                    this.printInvoiceDate(record.nextInvoiceGenerationDates).otherDocument &&
                    this.printInvoiceDate(record.nextInvoiceGenerationDates).otherDocument.length &&
                    this.printInvoiceDate(record.nextInvoiceGenerationDates).otherDocument[0].url ?
                    <div><br /><b>Other Documents:</b> <a href={MEDIA_URL + this.printInvoiceDate(record.nextInvoiceGenerationDates).otherDocument[0].url} target="_blank">View</a></div>
                    : null
                }
              </div>
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'Withdraw Finance Note',
        key: 'withdrawFinalStageNote',
        dataIndex: 'withdrawFinalStageNote',
        width: 100,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              <div>
                <b>Note:</b> {this.printInvoiceDate(record.nextInvoiceGenerationDates) && this.printInvoiceDate(record.nextInvoiceGenerationDates).withdrawFinalStageNote ? this.printInvoiceDate(record.nextInvoiceGenerationDates).withdrawFinalStageNote : 'N/A'}
                <br />
                <b>Status:</b> {this.printInvoiceDate(record.nextInvoiceGenerationDates) && this.printInvoiceDate(record.nextInvoiceGenerationDates).withdrawRequstStatus ? this.printInvoiceDate(record.nextInvoiceGenerationDates).withdrawRequstStatus : 'N/A'}
              </div>
            </React.Fragment>
          </div>
        )
      }
    ];

    return (
      <PageHeaderWrapper title={` Finance Withdraw Requests ${total} `}>
        {
          showWithdrawForm ?
            <WithdrawStudentRequestFinalStage onClose={this.closeWithdrawFrom} onSelect={(e) => this.withdrawStudent(e)} recordId={recordId} enableBTN={enableBTN} />
            : null
        }
        <Card bordered={true}>
          <TableComp
            ref={this.table}
            columns={columns}
            apiRequest={this.apiRequest}
            extraProps={{ scroll: { x: 900 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: defaultPageSize,
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllWithdrawFinalStage;
